import * as React from "react";
import { FoundedCompanies } from "./founded-companies";
import { Experiences } from "./experiences";
import { AboutProfile } from "./about-profile";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { NoContent } from "./no-content";
import "./about.scss";

interface ComponentProps {
  subject: Person | Entity;
}

export type Props = ComponentProps;

export const AboutPanel = (props: Props) => {
  const { subject } = props;
  return (
    <Container>
      <NoContent subject={subject}>
          <AboutProfile subject={subject} />
          <FoundedCompanies subject={subject} />
          <Experiences subject={subject} />
      </NoContent>
    </Container>
  );
};

const Container = ({ children }: React.PropsWithChildren<any>) => (
  <div className="tab-pane fade" id="About">
    <div className="about-panel">{children}</div>
  </div>
);
